module.exports = __webpack_public_path__ + "static/media/friends-feed.cbff43d1.webp";